<script setup>
import { computed } from 'vue';
import PieChart from 'shared/components/charts/PieChart.vue';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
});

const mergedOptions = computed(() => {
  return {
    cutout: '60%',
    ...props.chartOptions,
  };
});
</script>

<template>
  <PieChart
    variant="doughnut"
    :collection="collection"
    :chart-options="mergedOptions"
  />
</template>
